/**
 * CNAEs da PJ BR (`etiquetachef-br`) que o editor oferece em "Dados fiscais".
 *
 * Origem: #756 — 2026-10-01 15:28 +0200 (owner: "dropdown de CNAE para a entidade
 * etiquetachef-br em dados fiscais").
 *
 * Por quê: o CNAE ia em texto livre (7 dígitos), e um dígito trocado só
 * aparecia na recusa da NFS-e. A lista é a que o owner informou para a PJ,
 * com o item da LC 116 e o anexo do Simples de cada um. **6203-1/00 é o CNAE
 * da emissão de nota** (`forInvoice`). Mudar a lista é decisão fiscal do
 * owner — não acrescentar código por dedução.
 *
 * Dados: `value` = 7 dígitos, o formato que `SellerEntityBrFiscalSchema.cnae`
 * aceita e que vai ao Asaas (`sellerEntities.ts`, `cnae: f.cnae`). As
 * descrições são os nomes oficiais (IBGE/LC 116) e não se traduzem.
 *
 * Usado por: `SellerEntityEditorPage` (Select do CNAE).
 */
export type CnaeOption = {
  /** 7 dígitos, sem máscara (ex.: '6203100'). */
  value: string;
  /** Código mascarado do IBGE (ex.: '6203-1/00'). */
  code: string;
  description: string;
  /** Item da lista de serviços da LC 116/2003. */
  lc116: string;
  lc116Description: string;
  /** Anexos do Simples Nacional em que a atividade pode cair. */
  simplesAnnexes: readonly string[];
  /** O CNAE usado na emissão da NFS-e (owner, 2026-10-01). */
  forInvoice: boolean;
};

export const BR_ENTITY_CNAES: readonly CnaeOption[] = [
  {
    value: '6203100',
    code: '6203-1/00',
    description: 'Desenvolvimento e licenciamento de programas de computador não-customizáveis',
    lc116: '01.05',
    lc116Description: 'Licenciamento ou cessão de direito de uso de programas de computação.',
    simplesAnnexes: ['III'],
    forInvoice: true,
  },
  {
    value: '6319400',
    code: '6319-4/00',
    description: 'Portais, provedores de conteúdo e outros serviços de informação na internet',
    lc116: '01.07',
    lc116Description:
      'Suporte técnico em informática, inclusive instalação, configuração e manutenção de programas de computação e bancos de dados.',
    simplesAnnexes: ['III', 'V'],
    forInvoice: false,
  },
  {
    value: '6202300',
    code: '6202-3/00',
    description: 'Desenvolvimento e licenciamento de programas de computador customizáveis',
    lc116: '01.04',
    lc116Description:
      'Elaboração de programas de computadores, inclusive de jogos eletrônicos, independentemente da arquitetura construtiva da máquina em que o programa será executado, incluindo tablets, smartphones e congêneres',
    simplesAnnexes: ['III'],
    forInvoice: false,
  },
  {
    value: '6311900',
    code: '6311-9/00',
    description: 'Tratamento de dados, provedores de serviços de aplicação e serviços de hospedagem na internet',
    lc116: '01.03',
    lc116Description:
      'Processamento, armazenamento ou hospedagem de dados, textos, imagens, vídeos, páginas eletrônicas, aplicativos e sistemas de informação, entre outros formatos, e congêneres',
    simplesAnnexes: ['V', 'III'],
    forInvoice: false,
  },
  {
    value: '6204000',
    code: '6204-0/00',
    description: 'Consultoria em tecnologia da informação',
    lc116: '01.06',
    lc116Description: 'Assessoria e consultoria em informática.',
    simplesAnnexes: ['V'],
    forInvoice: false,
  },
];
